export default __webpack_public_path__ + "static/garden_design3-9f8b12db32bab64b337d950b254542ff.webp";